import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=5df893e1&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=5df893e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df893e1",
  null
  
)

export default component.exports